import { createContext } from "react";

export const UserAgentContext = createContext(false);
